import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { INITIAL_LANGUAGE, LanguageService } from './language.service';

/* istanbul ignore file */
@NgModule({})
export class LanguageModule {
    public constructor(@Optional() @SkipSelf() public parentModule: LanguageModule) {
        if (parentModule) {
            throw new Error('LanguageModule is already loaded. Import it once only!');
        }
    }

    public static forRoot(initialLanguage: string): ModuleWithProviders<LanguageModule> {
        return {
            ngModule: LanguageModule,
            providers: [{ provide: INITIAL_LANGUAGE, useValue: initialLanguage }, LanguageService],
        };
    }
}
